import React from 'react';

import {Icon} from '@pb/kit-component-icon';
import {
    Loading,
    LoadingHolder,
    Types as LoadingTypes,
} from '@pb/kit-component-loading';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './menu.module.styl';

import type {IconProps} from '@pb/kit-component-icon';


const classNames = withCssModule(styles);
type Props = {
    className?: string,
    icon: IconProps['type'],
    loader?: IconProps['loader'],
    iconSize?: IconProps['size'],
};
export const ItemIcon = ({
    className,
    icon,
    loader,
    iconSize,
}: Props) => (
    <span className={classNames('icon', className)}>
        <Icon type={icon} size={iconSize} loader={loader}/>
        {loader ? (
            <LoadingHolder>
                <Loading type={LoadingTypes.ICON}/>
            </LoadingHolder>
        ) : null}
    </span>
);
